function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import Somos1V2IndicadorTipo1Card from '../../components/Somos1V2IndicadorTipo1Card.vue';
import Somos1V2IndicadorTipo2Card from '../../components/Somos1V2IndicadorTipo2Card.vue';
import Somos1DataEntryService from '@/apps/customer-insigths/services/somos1_data_entry_service';
import somos1Service from '@/apps/customer-insigths/services/somos1_service';
import UserRegionAccessService from '@/apps/customer-insigths/services/somos1_user_region_access_service';
var Somos1V2RegionalIndicators1Page = /*#__PURE__*/function (_Vue) {
  function Somos1V2RegionalIndicators1Page() {
    var _this;
    _classCallCheck(this, Somos1V2RegionalIndicators1Page);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, Somos1V2RegionalIndicators1Page, [].concat(args));
    //#region Constantes
    _defineProperty(_this, "INDICADORES", {
      INGRESOS: 'INGRESOS',
      EBITDA_YTD: 'EBITDA',
      COLOCACIONES: 'COLOCACIONES',
      LOCALES: 'LOCALES',
      COLABORADORES: 'COLABORADORES',
      NPS: 'NPS',
      CLIMA_LABORAL: 'CLIMA LABORAL'
    });
    //#endregion
    //#region Props
    _defineProperty(_this, "idOrganization", void 0);
    _defineProperty(_this, "idBrand", void 0);
    _defineProperty(_this, "idIndicator", void 0);
    //#endregion
    //#region State
    _defineProperty(_this, "activeTab", 0);
    _defineProperty(_this, "selectedYear", new Date().getMonth() === 0 ? new Date().getFullYear() - 1 : new Date().getFullYear());
    _defineProperty(_this, "selectedYearString", String(new Date().getMonth() === 0 ? new Date().getFullYear() - 1 : new Date().getFullYear()));
    _defineProperty(_this, "selectedMonth", new Date().getMonth() === 0 ? 12 : new Date().getMonth());
    _defineProperty(_this, "selectedMonthString", '');
    _defineProperty(_this, "selectedRegion", '');
    _defineProperty(_this, "years", [0, 1, 2].map(function (i) {
      return {
        value: new Date().getFullYear() - i,
        text: String(new Date().getFullYear() - i)
      };
    }));
    _defineProperty(_this, "months", [{
      value: 1,
      text: 'Enero'
    }, {
      value: 2,
      text: 'Febrero'
    }, {
      value: 3,
      text: 'Marzo'
    }, {
      value: 4,
      text: 'Abril'
    }, {
      value: 5,
      text: 'Mayo'
    }, {
      value: 6,
      text: 'Junio'
    }, {
      value: 7,
      text: 'Julio'
    }, {
      value: 8,
      text: 'Agosto'
    }, {
      value: 9,
      text: 'Septiembre'
    }, {
      value: 10,
      text: 'Octubre'
    }, {
      value: 11,
      text: 'Noviembre'
    }, {
      value: 12,
      text: 'Diciembre'
    }]);
    _defineProperty(_this, "regions", []);
    _defineProperty(_this, "responseData", null);
    return _this;
  }
  _inherits(Somos1V2RegionalIndicators1Page, _Vue);
  return _createClass(Somos1V2RegionalIndicators1Page, [{
    key: "created",
    value: //#endregion
    //#region Lifecycle
    function () {
      var _created = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return this.fetchRegions();
            case 1:
              _context.n = 2;
              return this.fetchRegionalIndicators();
            case 2:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function created() {
        return _created.apply(this, arguments);
      }
      return created;
    }() //#endregion
    //#region Methods
  }, {
    key: "fetchRegions",
    value: function () {
      var _fetchRegions = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var _this2 = this;
        var userInfo, email, _yield$Promise$all, _yield$Promise$all2, regionsRes, accessRes, regiones, accessibleIds;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              userInfo = window.userInfo;
              email = userInfo && userInfo.email ? userInfo.email : null;
              if (email) {
                _context2.n = 1;
                break;
              }
              return _context2.a(2);
            case 1:
              _context2.n = 2;
              return Promise.all([Somos1DataEntryService.getRegionsList(), UserRegionAccessService.listByEmail(email)]);
            case 2:
              _yield$Promise$all = _context2.v;
              _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 2);
              regionsRes = _yield$Promise$all2[0];
              accessRes = _yield$Promise$all2[1];
              if (!(!regionsRes || !regionsRes.data || !accessRes || !accessRes.success)) {
                _context2.n = 3;
                break;
              }
              return _context2.a(2);
            case 3:
              // list_by_email devuelve un objeto { email, regiones: [{id_user_region_access, id_region}] }
              regiones = accessRes.data && accessRes.data.regiones ? accessRes.data.regiones : [];
              accessibleIds = new Set(regiones.map(function (a) {
                return String(a.id_region);
              }));
              this.regions = regionsRes.data.filter(function (r) {
                return accessibleIds.has(String(r.id_region));
              }).map(function (r) {
                return {
                  id: String(r.id_region),
                  name: r.name
                };
              });
              if (this.regions.length > 0 && !this.regions.find(function (r) {
                return r.name === _this2.selectedRegion;
              })) {
                this.selectedRegion = this.regions[0].name;
              }
            case 4:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function fetchRegions() {
        return _fetchRegions.apply(this, arguments);
      }
      return fetchRegions;
    }()
  }, {
    key: "fetchRegionalIndicators",
    value: function () {
      var _fetchRegionalIndicators = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var _this3 = this;
        var region, request, response, _t;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              this.showLoading(true);
              _context3.p = 1;
              region = this.regions.find(function (r) {
                return r.name === _this3.selectedRegion;
              });
              request = {
                id_regions: region ? [region.id] : ['0'],
                year: this.selectedYear,
                month: this.selectedMonth,
                id_organization: this.idOrganization
              };
              _context3.n = 2;
              return somos1Service.getRegionalIndicatorsV2(request);
            case 2:
              response = _context3.v;
              if (response && response.success) {
                this.responseData = response.data;
              } else {
                this.responseData = null;
              }
              _context3.n = 4;
              break;
            case 3:
              _context3.p = 3;
              _t = _context3.v;
              console.error(_t);
            case 4:
              _context3.p = 4;
              this.showLoading(false);
              return _context3.f(4);
            case 5:
              return _context3.a(2);
          }
        }, _callee3, this, [[1, 3, 4, 5]]);
      }));
      function fetchRegionalIndicators() {
        return _fetchRegionalIndicators.apply(this, arguments);
      }
      return fetchRegionalIndicators;
    }()
  }, {
    key: "showLoading",
    value: function showLoading(show) {
      this.$store.commit("app/setShowLoading", show);
    }
    //#endregion
    //#region Helpers
  }, {
    key: "toMM",
    value: function toMM(v) {
      if (v === null || v === undefined) return null;
      return v / 1000000;
    }
  }, {
    key: "applyMM",
    value: function applyMM(item) {
      return _objectSpread(_objectSpread({}, item), {}, {
        valor: this.toMM(item.valor)
      });
    }
    //#endregion
    //#region CSV Export
  }, {
    key: "downloadCsv",
    value: function downloadCsv() {
      var _this4 = this;
      var rows = [];
      rows.push(['Indicador', 'Negocio', 'Valor (S/mm)', 'Var. AA', 'Var. Ppto']);
      var addTipo1 = function addTipo1(title, items, total) {
        items.forEach(function (i) {
          rows.push([title, i.negocio, _this4.csvNum(i.valor), _this4.csvPct(i.var_anio_anterior), _this4.csvPct(i.var_presupuesto)]);
        });
        if (total) rows.push([title, 'TOTAL', _this4.csvNum(total.valor), _this4.csvPct(total.var_anio_anterior), _this4.csvPct(total.var_presupuesto)]);
      };
      var addTipo2Count = function addTipo2Count(title, items, total) {
        items.forEach(function (i) {
          rows.push([title, i.negocio, i.valor !== null && i.valor !== undefined ? String(i.valor) : '', '', '']);
        });
        if (total) rows.push([title, 'TOTAL', total.total_valor !== null && total.total_valor !== undefined ? String(total.total_valor) : '', '', '']);
      };
      var addTipo2Pct = function addTipo2Pct(title, items, total) {
        items.forEach(function (i) {
          rows.push([title, i.negocio, i.valor !== null && i.valor !== undefined ? i.valor + '%' : '', '', '']);
        });
        if (total) rows.push([title, 'PROMEDIO', total.total_valor !== null && total.total_valor !== undefined ? total.total_valor + '%' : '', '', '']);
      };
      addTipo1('Ventas', this.ingresosItems, this.ingresosTotal);
      addTipo1('EBITDA YTD', this.ebitdaItems, this.ebitdaTotal);
      addTipo1('Colocaciones', this.colocacionesItems, this.colocacionesTotal);
      addTipo2Count('Locales (#)', this.localesItems, this.localesTotal);
      addTipo2Count('Colaboradores (#)', this.colaboradoresItems, this.colaboradoresTotal);
      addTipo2Pct('NPS', this.npsItems, this.npsTotal);
      addTipo2Pct('Clima Laboral', this.climaItems, this.climaTotal);
      var csv = rows.map(function (r) {
        return r.map(function (c) {
          return '"' + c.replace(/"/g, '""') + '"';
        }).join(',');
      }).join('\n');
      var region = this.selectedRegion || 'sin_region';
      var filename = ('indicadores_regionales_' + region + '_' + this.periodLabel + '.csv').replace(/\s/g, '_');
      this.triggerCsvDownload(csv, filename);
    }
  }, {
    key: "csvNum",
    value: function csvNum(v) {
      if (v === null || v === undefined) return '';
      return v.toFixed(1);
    }
  }, {
    key: "csvPct",
    value: function csvPct(v) {
      if (v === null || v === undefined) return '';
      var sign = v >= 0 ? '+' : '';
      return sign + (v * 100).toFixed(1) + '%';
    }
  }, {
    key: "triggerCsvDownload",
    value: function triggerCsvDownload(content, filename) {
      var blob = new Blob(['﻿' + content], {
        type: 'text/csv;charset=utf-8;'
      });
      var url = URL.createObjectURL(blob);
      var a = document.createElement('a');
      a.href = url;
      a.download = filename;
      a.click();
      URL.revokeObjectURL(url);
    }
    //#endregion
    //#region Computed - Tipo 1
  }, {
    key: "ingresosItems",
    get: function get() {
      var _this5 = this;
      if (!this.responseData) return [];
      return this.responseData.indicadores_regionales_tipo_1.filter(function (i) {
        return i.indicador === _this5.INDICADORES.INGRESOS;
      }).map(function (i) {
        return _this5.applyMM(i);
      });
    }
  }, {
    key: "ingresosTotal",
    get: function get() {
      var _this6 = this;
      if (!this.responseData) return null;
      var item = this.responseData.total_indicadores_regionales_tipo_1.find(function (i) {
        return i.indicador === _this6.INDICADORES.INGRESOS;
      });
      return item ? this.applyMM(item) : null;
    }
  }, {
    key: "ebitdaItems",
    get: function get() {
      var _this7 = this;
      if (!this.responseData) return [];
      return this.responseData.indicadores_regionales_tipo_1.filter(function (i) {
        return i.indicador === _this7.INDICADORES.EBITDA_YTD;
      }).map(function (i) {
        return _this7.applyMM(i);
      });
    }
  }, {
    key: "ebitdaTotal",
    get: function get() {
      var _this8 = this;
      if (!this.responseData) return null;
      var item = this.responseData.total_indicadores_regionales_tipo_1.find(function (i) {
        return i.indicador === _this8.INDICADORES.EBITDA_YTD;
      });
      return item ? this.applyMM(item) : null;
    }
  }, {
    key: "colocacionesItems",
    get: function get() {
      var _this9 = this;
      if (!this.responseData) return [];
      return this.responseData.indicadores_regionales_tipo_1.filter(function (i) {
        return i.indicador === _this9.INDICADORES.COLOCACIONES;
      }).map(function (i) {
        return _this9.applyMM(i);
      });
    }
  }, {
    key: "colocacionesTotal",
    get: function get() {
      var _this0 = this;
      if (!this.responseData) return null;
      var item = this.responseData.total_indicadores_regionales_tipo_1.find(function (i) {
        return i.indicador === _this0.INDICADORES.COLOCACIONES;
      });
      return item ? this.applyMM(item) : null;
    }
    //#endregion
    //#region Computed - Tipo 2
  }, {
    key: "localesItems",
    get: function get() {
      var _this1 = this;
      if (!this.responseData) return [];
      return this.responseData.indicadores_regionales_tipo_1.filter(function (i) {
        return i.indicador === _this1.INDICADORES.LOCALES;
      });
    }
  }, {
    key: "localesTotal",
    get: function get() {
      var _this10 = this;
      if (!this.responseData) return null;
      var item = this.responseData.total_indicadores_regionales_tipo_1.find(function (i) {
        return i.indicador === _this10.INDICADORES.LOCALES;
      });
      return item ? _objectSpread(_objectSpread({}, item), {}, {
        total_valor: item.valor
      }) : null;
    }
  }, {
    key: "colaboradoresItems",
    get: function get() {
      var _this11 = this;
      if (!this.responseData) return [];
      return this.responseData.indicadores_regionales_tipo_1.filter(function (i) {
        return i.indicador === _this11.INDICADORES.COLABORADORES;
      });
    }
  }, {
    key: "colaboradoresTotal",
    get: function get() {
      var _this12 = this;
      if (!this.responseData) return null;
      var item = this.responseData.total_indicadores_regionales_tipo_1.find(function (i) {
        return i.indicador === _this12.INDICADORES.COLABORADORES;
      });
      return item ? _objectSpread(_objectSpread({}, item), {}, {
        total_valor: item.valor
      }) : null;
    }
  }, {
    key: "npsItems",
    get: function get() {
      var _this13 = this;
      if (!this.responseData) return [];
      return this.responseData.indicadores_regionales_tipo_1.filter(function (i) {
        return i.indicador === _this13.INDICADORES.NPS;
      });
    }
  }, {
    key: "npsTotal",
    get: function get() {
      var _this14 = this;
      if (!this.responseData) return null;
      var item = this.responseData.total_indicadores_regionales_tipo_1.find(function (i) {
        return i.indicador === _this14.INDICADORES.NPS;
      });
      return item ? _objectSpread(_objectSpread({}, item), {}, {
        total_valor: item.valor
      }) : null;
    }
  }, {
    key: "climaItems",
    get: function get() {
      var _this15 = this;
      if (!this.responseData) return [];
      return this.responseData.indicadores_regionales_tipo_1.filter(function (i) {
        return i.indicador === _this15.INDICADORES.CLIMA_LABORAL;
      });
    }
  }, {
    key: "climaTotal",
    get: function get() {
      var _this16 = this;
      if (!this.responseData) return null;
      var item = this.responseData.total_indicadores_regionales_tipo_1.find(function (i) {
        return i.indicador === _this16.INDICADORES.CLIMA_LABORAL;
      });
      return item ? _objectSpread(_objectSpread({}, item), {}, {
        total_valor: item.valor
      }) : null;
    }
    //#endregion
  }, {
    key: "periodLabel",
    get: function get() {
      var _this17 = this;
      var m = this.months.find(function (x) {
        return x.value === _this17.selectedMonth;
      });
      return m ? "".concat(m.text, " ").concat(this.selectedYear) : "".concat(this.selectedYear);
    }
  }]);
}(Vue);
__decorate([Prop({
  default: 20
})], Somos1V2RegionalIndicators1Page.prototype, "idOrganization", void 0);
__decorate([Prop({
  default: '0'
})], Somos1V2RegionalIndicators1Page.prototype, "idBrand", void 0);
__decorate([Prop({
  default: '0'
})], Somos1V2RegionalIndicators1Page.prototype, "idIndicator", void 0);
Somos1V2RegionalIndicators1Page = __decorate([Component({
  components: {
    Somos1V2IndicadorTipo1Card: Somos1V2IndicadorTipo1Card,
    Somos1V2IndicadorTipo2Card: Somos1V2IndicadorTipo2Card
  }
})], Somos1V2RegionalIndicators1Page);
export default Somos1V2RegionalIndicators1Page;